import React from 'react'
import styled from '@emotion/styled'
import {
  device,
  color,
  fontSize,
  fontWeight,
  lineHeight,
  space,
  radius,
} from '@ticketswap/solar'
import { TicketSwap } from '@ticketswap/comets'

const Wrapper = styled.div`
  backdrop-filter: blur(4px);
  border-radius: ${radius.lg};
  box-shadow: 0 2px 12px 0px rgba(0, 19, 25, 0.2),
    0 1px 17px 2px rgba(0, 19, 25, 0.1);
  display: flex;
  flex-direction: column;
  font-size: ${fontSize[12]};
  max-width: 360px;
  padding: 10px 12px 10px 10px;
  text-align: left;
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;

  @media ${device.tablet} {
    font-size: ${fontSize[14]};
    padding: ${space[12]} ${space[16]} ${space[12]} ${space[12]};
  }

  &:after {
    bottom: 0;
    content: '';
    background: white;
    border-radius: ${radius.lg};
    height: 100%;
    left: 0;
    opacity: 0.9;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
  }
`

const Header = styled.div`
  color: ${color.spaceLight};
  font-size: 10px;
  display: flex;
  margin-bottom: ${space[4]};
  line-height: ${lineHeight.solid};
  position: relative;
  text-transform: uppercase;
  z-index: 2;

  > span {
    align-items: center;
    display: flex;
  }

  > span:last-of-type {
    align-items: end;
    margin-left: auto;
    text-transform: lowercase;
  }

  @media ${device.tablet} {
    font-size: ${fontSize[12]};
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2px;
  position: relative;
  z-index: 2;

  > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  @media ${device.tablet} {
    padding: ${space[4]};
  }
`

const LogoWrapper = styled.div`
  background: ${color.earth};
  border-radius: ${radius.sm};
  color: white;
  display: flex;
  height: ${space[16]};
  margin-right: 6px;
  width: ${space[16]};

  > span {
    margin: auto;
  }

  @media ${device.tablet} {
    height: 20px;
    margin-right: ${space[8]};
    width: 20px;

    > span {
      height: 14px;
      width: 14px;
    }
  }
`
const Title = styled.span`
  font-weight: ${fontWeight.semiBold};
`

function AppsAdoptionNotification({ t, eventName, ...props }) {
  return (
    <Wrapper {...props}>
      <Header>
        <LogoWrapper>
          <TicketSwap size={12} />
        </LogoWrapper>
        <span>TicketSwap</span>
        <span>{t('common:generic.now')}</span>
      </Header>
      <Content>
        <Title>
          {eventName ? eventName : t('common:appsAdoption.notification.title')}
        </Title>
        <span>{t('common:appsAdoption.notification.text')}</span>
      </Content>
    </Wrapper>
  )
}

export default AppsAdoptionNotification
